"use client";
import React, { useEffect, useState, useRef } from "react";
import styles from "@components/CustomComponents/LocatorStore/Map/index.module.scss";
import dynamic from "next/dynamic";

const ReactBingmaps = dynamic(
  () => import("react-bingmaps").then(mod => mod.ReactBingmaps),
  { ssr: false }
);
const DEFAULT_LOCATION = [21.033333, 105.84999]; // Hanoi, Vietnam

const MapView = props => {
  const {
    location = {},
    locationResult = [],
    showPopup = false,
    setShowPopup,
    markerData = [],
  } = props;

  const [center, setCenter] = useState(
    location && location?.latitude && location?.longitude
      ? [location.latitude, location.longitude]
      : DEFAULT_LOCATION
  );
  const mapRef = useRef(null);

  useEffect(() => {
    if (location && location?.latitude && location?.longitude) {
      setCenter([location.latitude, location.longitude]);
    }
  }, [location]);

  useEffect(() => {
    if (markerData && markerData?.Latitude && markerData?.Longitude) {
      setCenter([markerData.Latitude, markerData.Longitude]);
    }
  }, [markerData]);

  const getMarkerColor = classification => {
    switch (classification) {
      case "KEC":
        return "#84A648";

      case "Distributor":
        return "#00a7ce";

      case "Dealer":
        return "#9d9d9d";
    }
  };

  return (
    <div className={styles.mapWrapper} ref={mapRef}>
      <ReactBingmaps
        className={styles["react-bingmaps"]}
        bingmapKey={process.env.NEXT_PUBLIC_MAP_KEY}
        center={center}
        zoom={10}
        key={"klafs-map"}
        disableStreetside={true}
        navigationBarMode={"square"}
        mapOptions={{
          showMapTypeSelector: true,
          NavigationBarMode: "square",
          disableScrollWheelZoom: true,
        }}
        infoboxes={
          showPopup
            ? [
                {
                  location: [markerData?.Latitude, markerData?.Longitude],
                  option: {
                    visible: true,
                    title: "",
                    description: `<div class="customInfobox" style="
                          width: 100%;height:100%;   
                          font-family: sans-serif; 
                          width:260px;
                          max-width:260px;
                          background:#ffffff;
                          overflow:hidden;    
                          box-sizing:border-box;
">
              <h3 style="display:flex;">
                  <span style="background:${getMarkerColor(markerData?.ContactClassification)};;
                               margin-right:5px;
                               color:white;
                               font-weight:bold;
                               width:20px;
                              height:20px;
                              display:flex;
                              align-items:center;
                              justify-content:center">
                   ${markerData?.id}
                  </span>
                  <span 
                  style="display:flex;
                    align-items:center;
                    justify-content:center;
                    font-weight:bold;
                    font-size:13px;
                    color:#000;
                    word-wrap:break-word">  ${markerData?.LocationName}</span>
                </h3>
                <h3 style="margin-left:20px;color:#000;word-break: break-all;                   
                      white-space:normal;
                      overflow:hidden;
">
                  ${markerData?.AddressLine} ,${markerData?.Locality} ${markerData?.Phone} 
                 ${
                   markerData?.WebURL
                     ? `
                        <span style="margin-top:8px;">
                          <a
                            href="${markerData.WebURL}"
                            target="_blank"
                            rel="noopener noreferrer"
                            style="
                              color:#2563eb;
                              text-decoration:underline;
                              font-weight:500;
                            "
                          >
                            Visit Website
                          </a>
                        </span>
                      `
                     : ""
                 }
                </h3>
              </div>
            `,
                  },
                },
              ]
            : []
        }
        pushPins={locationResult.map(locs => ({
          location: [locs.lat, locs.lng],
        }))}
      />
    </div>
  );
};

export default React.memo(MapView);
